/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropedit1Inputs */

const en_dropedit1 = /** @type {(inputs: Dropedit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit drop`)
};

const de_dropedit1 = /** @type {(inputs: Dropedit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop bearbeiten`)
};

/**
* | output |
* | --- |
* | "Edit drop" |
*
* @param {Dropedit1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropedit1 = /** @type {((inputs?: Dropedit1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropedit1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropedit1(inputs)
	return de_dropedit1(inputs)
});
export { dropedit1 as "dropEdit" }